/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S3_Li1Inputs */

const tr_kvkkbasvuru_s3_li1 = /** @type {(inputs: Kvkkbasvuru_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad, soyad ve başvuru yazılı ise imza`)
};

const en_kvkkbasvuru_s3_li1 = /** @type {(inputs: Kvkkbasvuru_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name, surname and, if the application is in writing, signature`)
};

const de_kvkkbasvuru_s3_li1 = /** @type {(inputs: Kvkkbasvuru_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor- und Nachname sowie Unterschrift, wenn der Antrag schriftlich erfolgt`)
};

const ru_kvkkbasvuru_s3_li1 = /** @type {(inputs: Kvkkbasvuru_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя, фамилия и подпись, если обращение подаётся в письменной форме`)
};

/**
* | output |
* | --- |
* | "Name, surname and, if the application is in writing, signature" |
*
* @param {Kvkkbasvuru_S3_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s3_li1 = /** @type {((inputs?: Kvkkbasvuru_S3_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S3_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s3_li1(inputs)
	if (locale === "de") return de_kvkkbasvuru_s3_li1(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s3_li1(inputs)
	return tr_kvkkbasvuru_s3_li1(inputs)
});